/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusUploadLimitsDto } from '../../models/lexplus-upload-limits-dto';

export interface UploadsControllerGetLimitsV1$Params {
}

export function uploadsControllerGetLimitsV1(http: HttpClient, rootUrl: string, params?: UploadsControllerGetLimitsV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusUploadLimitsDto>> {
  const rb = new RequestBuilder(rootUrl, uploadsControllerGetLimitsV1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusUploadLimitsDto>;
    })
  );
}

uploadsControllerGetLimitsV1.PATH = '/v1/uploads/limits';
